import { company, email, name, phoneNumber, website } from './constants'

export const giftingApplicationJson = [
  name,
  email,
  phoneNumber,
  company,
  website,
  // compliance,
]
